import { useQuery } from 'react-query';
import getOrders from 'data/requests/getOrders';
import { Order } from 'model/orders';

const useOrders = () => {
  const { data } = useQuery<Order[]>('orders', getOrders, { enabled: true });

  // The request is done from useSocket
  // component will be loading until useSocket receive the orders (or fail)
  return { orders: data, isLoading: !data };
};

export default useOrders;
